"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletPOI = void 0;
const engine_1 = require("@railgun-community/engine");
const wallet_poi_requester_1 = require("./wallet-poi-requester");
const shared_models_1 = require("@railgun-community/shared-models");
class WalletPOI {
    static started = false;
    static init(poiNodeInterface, customLists) {
        const poiLists = [...shared_models_1.POI_REQUIRED_LISTS, ...customLists];
        engine_1.POI.init(poiLists, poiNodeInterface);
        this.started = true;
    }
    static getPOITxidMerklerootValidator = (poiNodeURLs) => {
        const poiRequester = new wallet_poi_requester_1.WalletPOIRequester(poiNodeURLs);
        const txidMerklerootValidator = (txidVersion, chain, tree, index, merkleroot) => poiRequester.validateRailgunTxidMerkleroot(txidVersion, chain, tree, index, merkleroot);
        return txidMerklerootValidator;
    };
    static getPOILatestValidatedRailgunTxid = (poiNodeURLs) => {
        const poiRequester = new wallet_poi_requester_1.WalletPOIRequester(poiNodeURLs);
        const getLatestValidatedRailgunTxid = (txidVersion, chain) => poiRequester.getLatestValidatedRailgunTxid(txidVersion, chain);
        return getLatestValidatedRailgunTxid;
    };
}
exports.WalletPOI = WalletPOI;
